module.exports = __webpack_public_path__ + "logo_gengji1.png?f8124e56e320c5ba1548da5cee21b6d3";